var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssessment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6663 10.416V5.66602C16.6663 4.26588 16.6663 3.56582 16.3939 3.03104C16.1542 2.56063 15.7717 2.17818 15.3013 1.9385C14.7665 1.66602 14.0665 1.66602 12.6663 1.66602H7.33301C5.93288 1.66602 5.23281 1.66602 4.69803 1.9385C4.22763 2.17818 3.84517 2.56063 3.60549 3.03104C3.33301 3.56582 3.33301 4.26588 3.33301 5.66602V14.3327C3.33301 15.7328 3.33301 16.4329 3.60549 16.9677C3.84517 17.4381 4.22763 17.8205 4.69803 18.0602C5.23281 18.3327 5.93288 18.3327 7.33301 18.3327H9.99967M11.6663 9.16602H6.66634M8.33301 12.4993H6.66634M13.333 5.83268H6.66634M12.083 15.8327L13.7497 17.4993L17.4997 13.7493",
    stroke: "#0265DC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessment);
export default __webpack_public_path__ + "static/media/assessment.15ba7ea4635e8ba0c9fb84030006b93c.svg";
export { ForwardRef as ReactComponent };